import React, { useState, useEffect, useMemo, Fragment } from "react"
import { useDispatch } from "react-redux"
import { withRouter } from "react-router"
import { Box, CircularProgress } from "@material-ui/core"
import { MuiThemeProvider } from "@material-ui/core/styles"
import billingTheme from "../../themes/billing"
import { isEmpty } from "lodash"
import { getClientDealMemo } from "../../actions/billing-crew-client"
import EstimateCardBillingClient from "../../components/Billing/Client/EstimateCardBillingClient/index"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar/index"
import ClientEstimateRightActions from "../../components/Billing/Client/ClientEstimateRightActions/index"
import DownloadPdfButton from "../../components/Billing/Common/DownloadPdfButton/index"
import calculateTotals from "../../utils/calculateTotals"
import CopyLinkButton from "../../components/Billing/Common/CopyLinkButton/index"
import BillingPageLayout from "../../components/Billing/Common/BillingPageLayout/index"
import useActiveCompanyAdesk from "../../hooks/useActiveCompanyAdesk"
import convertAdeskToOrganization from "../../utils/convertAdeskToOrganization"
import { adeskPhones } from "../../utils/adeskPhones"
import { Button } from "@material-ui/core"
import LinkIcon from "@material-ui/icons/Link"
import copy from "copy-to-clipboard"



const ClientEstimateContent = props => {
  const dispatch = useDispatch()
  let shortCode = props.match.params.short_code

  //master local state for all client estimate components
  const [localEstimateData, setLocalEstimateData] = useState({})

  // Make call to populate the state val being used in the tables, etc.
  useEffect(() => {
    dispatch(getClientDealMemo(shortCode)).then(res => {
      setLocalEstimateData(res)
      return res
    })
  }, [])

  let estimateCrewArray = useMemo(
    () => {
      if (
        (localEstimateData && localEstimateData.roles) ||
        localEstimateData.users
      ) {
        return [...localEstimateData.roles, ...localEstimateData.users].sort(
          (a, b) => a.shoot_role_id - b.shoot_role_id
        )
      } else {
        return []
      }
    },
    [localEstimateData]
  )

  const isAdesk =
    useActiveCompanyAdesk() ||
    (localEstimateData && localEstimateData.company_id === 2)

  const amounts = useMemo(
    () => {
      if (localEstimateData && estimateCrewArray) {
        let depositPaidAmount =
          Boolean(localEstimateData.deposit_required) &&
            Boolean(localEstimateData.first_paid)
            ? localEstimateData.first_half_amount
            : 0
        return calculateTotals(
          estimateCrewArray,
          depositPaidAmount,
          localEstimateData.discount
        )
      }
    },
    [localEstimateData]
  )

  const copyLink = () => {
    copy(window.location.href)
  }


  const checkDiscount = useMemo(
    () => {
      let discountArr = []
      // map over combined list of users & roles to find discounts in reg expenses only (no additional)
      estimateCrewArray.map(x =>
        x.expenses.filter(y => {
          if (y.discount && y.discount > 0) {
            discountArr = [...discountArr, y]
          }
          return discountArr
        })
      )
      return discountArr.length > 0
    },
    [estimateCrewArray]
  )

  if (isEmpty(localEstimateData) || !estimateCrewArray) {
    return <CircularProgress />
  } else {
    return (
      <BillingPageLayout
        // Left side content
        leftHeader={`Estimate for ${localEstimateData.shoot_name}`} //+ shootName
        leftContent={
          <Box style={{ paddingTop: "14px" }}>
            <EstimateCardBillingClient
              {...props}
              dealMemoData={localEstimateData}
              setDealMemoData={setLocalEstimateData}
              estimateCrewArray={estimateCrewArray}
              checkDiscount={checkDiscount}
            />
          </Box>
        }
        //Start of the right side content
        rightHeader="Actions"
        rightHeaderButtons={
          <Fragment>
            <DownloadPdfButton
              type="estimate"
              data={{
                ...localEstimateData,
                users: estimateCrewArray,
                passedAmounts: amounts,
                company_name:
                  isAdesk &&
                    (localEstimateData && localEstimateData.crewmama_or_gtt)
                    ? convertAdeskToOrganization(
                      localEstimateData.crewmama_or_gtt
                    )
                    : localEstimateData.company_name,
                company_phone: isAdesk
                  ? adeskPhones(localEstimateData.crewmama_or_gtt)
                  : localEstimateData.company_phone,
                hasLineDiscounts: checkDiscount,
              }}
              client={true}
            />
            <Box width="10px" />



            <Button
              onClick={copyLink}

              size="small"
              variant="outlined"
              style={{
                border: "0px solid #EBEBEB",
                borderRadius: "5px",
                backgroundColor: "#EBEBEB",
              }}

            >
              <LinkIcon />
              Copy Link
            </Button>
          </Fragment>
        }
        rightContent={
          <ClientEstimateRightActions
            dealMemoData={localEstimateData}
            setDealMemoData={setLocalEstimateData}
            estimateCrewArray={estimateCrewArray}
          />
        }
      />
    )
  }
}

const ClientEstimatePage = props => {
  return (
    <MuiThemeProvider theme={billingTheme}>
      <CrewMamaAppBarComponent />
      <ClientEstimateContent {...props} />
    </MuiThemeProvider>
  )
}

export default withRouter(ClientEstimatePage)
